/*
 * @Author: Gaho
 * @Date: 2024-01-24 14:25:28
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-25 11:28:49
 */
import { defineStore } from "pinia";

export const useCoinFlipStore = defineStore("coinflip", {
    state: () => ({
        accData: {  // Multiply模式下的下注数据
            
        } as any,
        betOrBack: '', // bet: 下注 back: 返现
    })
})